export default 'M0 0h10.5v10.5H0zm2 2v6.5h6.5V2zM13.5 0H24v10.5H13.5zm2 2v6.5H22V2zM0 13.5h10.5V24H0zm2 2V22h6.5v-6.5zM13.5 13.5H24V24H13.5zm2 2V22H22v-6.5z';